export default function useEventmapHandlers({
  modalState,
  selectedLocation,
  routeStart,
  routeEnd,
  eventmapSVG,
  eventmap,
  props,
}) {
  const onLocationSelected = (location) => {
    modalState.value = 'expanded';
    selectedLocation.value = location;
    eventmapSVG.value?.zoomToLocation?.(location);
    setTimeout(() => {
      document.getElementById(`locationList_${location.unique_key}`)?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }, 500);
  };

  const setStartPoint = (location) => {
    routeStart.value = location;
    modalState.value = 'navigate';
  };

  const setEndPoint = (location) => {
    routeEnd.value = location;
    modalState.value = 'navigate';
  };

  const previewLocation = () => {
    if (selectedLocation.value?.routes?.preview) {
      window.location.hash = selectedLocation.value.routes.preview;
    }
  };

  const zoomSoon = () => {
    const findLocationById = (id) => eventmap.value?.locations?.find((loc) => loc.id === id);
    if (props.locationId) {
      setTimeout(() => {
        const location = findLocationById(props.locationId);
        if (location) {
          eventmapSVG.value?.zoomToLocation?.(location);
          selectedLocation.value = location;
        }
      }, 1000);
    } else if (props.mode === 'kiosk' && props.kioskLocationId) {
      const kioskLocation = findLocationById(props.kioskLocationId);
      if (kioskLocation) {
        routeStart.value = kioskLocation;
      }
    }
  };

  return {
    onLocationSelected,
    setStartPoint,
    setEndPoint,
    previewLocation,
    zoomSoon,
  };
}
